<template>
  <div>
    <b-row class="m-0">
      <b-col
        tag="strong"
        cols="6"
        md="6"
        class="text-primary px-0 d-flex align-items-end"
        v-text="title"
      />
      <b-col cols="6" md="6" class="text-right px-0 mb-2">
        <b-button v-if="hasNextBtn" variant="primary" @click="$emit('next')">
          <span v-text="$lang.submitNext" />
          <i class="fas fa-chevron-left ml-2" />
        </b-button>
      </b-col>
    </b-row>
    <b-row class="m-0 mb-1">
      <b-col cols="12" md="" class="px-0">
        <b-table
          class="text-center bg-white table_white mb-0"
          bordered
          responsive
          :fields="fields"
          :items="items"
        />
      </b-col>
      <b-col
        v-if="readMoreLink"
        cols="12"
        md="auto"
        class="d-flex align-items-end px-0 pb-0"
      >
        <b-button
          variant="link"
          class="text-primary pb-0"
          v-text="$lang.read_more"
          @click="$emit('showWindowModal', true, 'educationWindow')"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { pathOr } from "ramda";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    readMoreLink: {
      type: Boolean,
      default: true,
    },
    hasNextBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    pathOr,
  },
};
</script>

<style lang="scss">
.table_white {
  /* th,
  tr,
  td {
    border-color: #63c2de !important;
  } */
  tr {
    background-color: #fff !important;
  }
}
</style>